<template>
  <div class="content-text">
    <h2 class="content-text__title" v-html="title" v-if="content.title"></h2>
    <div class="content-text__wysiwyg" v-html="wysiwyg"></div>
  </div>
</template>

<script>
export default {
  name: 'ContentText',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    title () {
      return this.content.title
    },
    wysiwyg () {
      return this.content.wysiwyg.join('')
    }
  }
}
</script>

<style lang="scss">
  .content-text{

    &:not(:last-of-type){
      margin-bottom: layout("spacing");
    }

    // Title

    &__title{
      @include title;
      margin: 0;
      color: white;
      line-height: 1.2;
      margin-bottom: layout("spacing")*2;
      font-family: get($font-families, "secondary");
    }

    // Wysiwyg

    &__wysiwyg{
      h3{
        @include media("small"){
          // font-size: 2.8rem;
          font-size: 1.8rem;
        }
        @include media("medium"){
          // font-size: 3rem;
          font-size: 2rem;
        }
        @include media("large"){
          // font-size: 3.2rem;
          font-size: 2.3rem;
        }

        margin: 0;
        color: white;
        line-height: 1.2;
        margin-bottom: layout("spacing")*1.5;
        font-family: get($font-families, "secondary");
        font-weight: font-weights("light");
      }

      p{
        @include media("small"){
          font-size: 1.6rem;
        }
        @include media("medium-large"){
          font-size: 1.6rem;
        }

        margin-top: 0;
        line-height: 1.9;
        color: white;
        margin-bottom: layout("spacing");
      }

      a{
        @include add-transition;
        @include hover{
          color: rgba(white, 1);
        }
        color: rgba(white, 0.3);
      }

      img{
        margin-bottom: layout("spacing");
      }

      .add-margin-bottom{
        margin-bottom: layout("spacing")*2;
      }
    }
  }
</style>
